export function basePersonNameReducer( state = '', action ){
    switch( action.type ){
        case "SET_BASE_PERSON_NAME": return action.payload
        default: return state
    }
}
export function basenPersonEmailReducer( state = '', action ){
    switch( action.type ){
        case "SET_BASE_PERSON_EMAIL": return action.payload
    default: return state
    }
}
export function basePersonPhoneReducer( state = '', action ){
    switch( action.type ){
        case "SET_BASE_PERSON_PHONE_NUMBER": return action.payload
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/base-person/reducers.js